import React from 'react';

import { Typography } from '@zydalabs/storefront-components';
import { StyledTabsWrapper, StyledTab, StyledContainer } from './style';
import { TabsComponentProps } from './types';
import LazyLoadingTabs from './LazyLoadingTabs';

const Tabs: React.FC<TabsComponentProps> = ({
  tabs,
  value,
  onChange,
  disabledTab,
  isLoading,
  justifyContent = 'flex-start',
  margin,
  variant,
  showHeader = true,
  ...props
}) => {
  const blockTabTextVariant = variant === 'block' ? 'smallText' : 'headlineBody';

  return (
    <>
      {isLoading ? (
        <StyledTabsWrapper justifyContent={justifyContent} margin={margin}>
          <LazyLoadingTabs tabsNumber={tabs.length} />
        </StyledTabsWrapper>
      ) : (
        <StyledContainer>
          <StyledTabsWrapper justifyContent={justifyContent} margin={margin} variant={variant}>
            {tabs &&
              showHeader &&
              tabs.map(tab => (
                <StyledTab
                  onClick={event => {
                    if (tab.tabValue !== disabledTab) {
                      if (tab.onClick) {
                        tab.onClick(event);
                      }
                      onChange(tab.tabValue);
                    }
                  }}
                  isActiveTab={tab.tabValue === value}
                  key={tab.name}
                  id={tab.name}
                  isDisabledTab={tab.tabValue === disabledTab}
                  variant={variant}
                  data-testid={tab.tabValue === value ? 'active' : tab.name}
                  {...props}
                >
                  <>
                    {tab.prefix && tab.prefix}
                    <Typography
                      variant={variant === 'category' ? 'body1' : blockTabTextVariant}
                      cursor={tab.tabValue === disabledTab ? 'default' : 'pointer'}
                    >
                      {tab.name}
                    </Typography>
                  </>
                </StyledTab>
              ))}
          </StyledTabsWrapper>
          {tabs && tabs.map(tab => tab.tabValue === value && tab.component && <div key={tab.name}>{tab.component}</div>)}
        </StyledContainer>
      )}
    </>
  );
};

export default Tabs;
